import { useState, useCallback } from 'react';
import { apiService } from '@/services/api';
import { useAuth } from '@/contexts/AuthContext';
import { useCommunities } from '@/contexts/CommunitiesContext';

export function useDeletePost() {
    const { token } = useAuth();
    const { removeCommunityPost, addDeletedPostId } = useCommunities();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const deletePost = useCallback(async (postId: string, communityId?: string) => {
        if (!token) return false;

        setLoading(true);
        setError(null);
        try {
            await apiService.deletePost(postId, token);

            // Update local state and context
            if (communityId) {
                removeCommunityPost(communityId, postId);
            }
            addDeletedPostId(postId);

            return true;
        } catch (err: any) {
            setError(err.message || 'Failed to delete post');
            return false;
        } finally {
            setLoading(false);
        }
    }, [token, removeCommunityPost, addDeletedPostId]);

    return { deletePost, loading, error };
}
